import { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { toast } from 'react-toastify';

import { ModalForm } from 'components/ModalForm';
import { useModal } from 'context/ModalProvider/useModal';
import { ValidationGroup } from 'devextreme-react';
import { INITIAL_ACCOUNT_EDIT } from 'pages/Accounts/Accounts.constants';
import { AccountEdit } from 'pages/Accounts/Accounts.entity';
import { useChangeAccountMutation, useLazyGetAccountDetailQuery } from 'pages/Accounts/api/accounts';
import { AccountEditForm } from 'pages/Accounts/components';
import $createDataSource from 'utils/create-data-souce-instance';
import { isSuccess } from 'utils/responseStatus';

type Props = {
  id: number;
  onRefresh: () => void;
};

export const EditUserModal: FC<Props> = ({ id, onRefresh }) => {
  const { hideModal } = useModal();
  const modalValidateRef = useRef<ValidationGroup>(null);

  const [form, setForm] = useState<AccountEdit>(INITIAL_ACCOUNT_EDIT);

  const [changeAccount] = useChangeAccountMutation();
  const [getAccountDetail] = useLazyGetAccountDetailQuery();

  const employeeDateSource = useMemo(() => {
    return $createDataSource('/v1/employee', 'id');
  }, []);

  const storeRole: any = useMemo(() => {
    return $createDataSource('/v1/role', 'id', { pageSize: 20, paginate: false });
  }, []);

  const getInitData = useCallback(async () => {
    getAccountDetail({ id }).then((data) => {
      if (isSuccess(data)) {
        data?.data && setForm(data.data);
      }
    });
  }, [getAccountDetail, id]);

  useEffect(() => {
    getInitData();
  }, [getInitData]);

  const handleChange = (name: keyof AccountEdit, value: AccountEdit[keyof AccountEdit]) => {
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    const isValid = modalValidateRef.current?.instance.validate().isValid;

    if (!isValid || !form) return;

    changeAccount(form).then((data) => {
      if (isSuccess(data)) {
        onRefresh();
        hideModal();
        toast.success('Учетная запись успешно обновлена', {
          position: 'bottom-right',
        });
      }
    });
  };

  return (
    <ModalForm
      onHidden={hideModal}
      title="Редактирование пользователя"
      visible
      isLoadingSubmit={false}
      width={500}
      height="auto"
      textConfirm="Сохранить"
      hideOnOutsideClick={false}
      onSubmit={handleSubmit}
      ref={modalValidateRef}
    >
      <AccountEditForm
        employeeDateSource={employeeDateSource}
        form={form}
        onChange={handleChange}
        roleSource={storeRole}
      />
    </ModalForm>
  );
};
